import React from 'react';
import './styles/style.css';
import { HashRouter, Route, Switch } from 'react-router-dom';

import { INGRESO_ROUTE } from './config/routes';
import { CATALOGO_ROUTE } from './config/routes';

import Ingreso from './components/ingreso.component'
import Catalogo from './components/catalogo.component' 

interface Props {

}
interface State {

}
class App extends React.Component<Props,State> {
    render() {
        return (
            <HashRouter>
                <div>
                    <Switch>
                        <Route 
                            path = {INGRESO_ROUTE}
                            component = {Ingreso}
                            exact
                        />
                        <Route 
                            exact
                            path = {CATALOGO_ROUTE}
                            component = {Catalogo}
                        />
                    </Switch>
                </div>
            </HashRouter>
        )
    }
}

export default App